import { render, staticRenderFns } from "./marques.vue?vue&type=template&id=c3893710"
import script from "./marques.vue?vue&type=script&lang=js"
export * from "./marques.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports